import { FC } from 'react';
import { EuDdpOrders } from 'components/EuDdpOrders';
import { Page } from 'layouts/Page';

export const EuDdpOrdersPage: FC = () => {
	return (
		<Page title="EU DDP Orders – EAS Control Center">
			<EuDdpOrders />
		</Page>
	);
};
